import React, { memo } from 'react';
import styled from 'styled-components/macro';
import { find, findIndex, some } from 'lodash';
import { LIST_ITEMS_SIZE } from 'config';
import scaleSize from 'utils/scale-size';
import { SeasonType, EpisodeType } from 'store/pages/loaders/loader-types';
import HorizontalList from 'components/HorizontalList';
import ListItem, { LIST_ITEM_MARGIN } from 'components/CustomCollection/ListItem';

const listConfig = {
  enterTo: 'last-focused',
  leaveFor: {
    right: '',
    bottom: '',
  },
  debounce: {
    time: 150,
    options: {
      leading: true,
      trailing: false,
      maxWait: 200,
    },
  },
};

export const StyledEpisodesTitle = styled.div`
  color: ${({ theme }) => theme.detailsMetadataTextColor};
  height: ${scaleSize(48)}px;
  font-size: ${scaleSize(40)}px;
  line-height: 1.2;
  margin-top: ${scaleSize(21)}px;
  margin-left: ${scaleSize(220)}px;
`;

export const StyledEpisodeslList = styled(HorizontalList)`
  height: ${scaleSize(712)}px;
  transform: translateY(${({ extraOffset }) => extraOffset || 0}px);
  margin-top: ${scaleSize(35)}px;
  margin-left: ${scaleSize(224)}px;
  position: relative;
  white-space: nowrap;
`;

interface IEpisodes {
  seasons: SeasonType[];
  onEnter: (item: EpisodeType) => void;
  onFocus?: () => void;
  focusedEpisodeId: number;
}

const itemSize = LIST_ITEMS_SIZE.LARGE.width + LIST_ITEM_MARGIN;

const Episodes: React.FC<IEpisodes> = ({ seasons, onEnter, onFocus, focusedEpisodeId }) => {
  const currentSeason = find(seasons, ({ episodes }) => some(episodes, { id: focusedEpisodeId }));
  const { id, name, episodes } = currentSeason || {};
  const listId = `episodes-list-${id}`;
  const defaultElementIndex = findIndex(episodes, { id: focusedEpisodeId });

  if (!currentSeason) return null;

  return (
    <div>
      <StyledEpisodesTitle>{name}</StyledEpisodesTitle>
      <StyledEpisodeslList
        listId={listId}
        sectionName={'EPISODES'}
        itemSize={itemSize}
        startScrollIndex={1}
        items={episodes}
        onEnter={onEnter}
        onFocus={onFocus}
        defaultIndex={defaultElementIndex}
        config={{ ...listConfig }}
        itemRender={(props) => {
          const isActive = props.index === defaultElementIndex;
          return <ListItem.EPISODE {...props} isActive={isActive} />;
        }}
      />
    </div>
  );
};

export default memo(Episodes);
